import { Trash2, Mail, Phone, Check } from "lucide-react";
import { formatDate } from "../../lib/adminApi";

const DoneToggle = ({ c, onToggle }) => (
    <button
        data-testid={`admin-toggle-${c.id}`}
        onClick={() => onToggle(c)}
        aria-pressed={c.erledigt}
        title={c.erledigt ? "Als offen markieren" : "Als beantwortet markieren"}
        className={`mt-1 w-6 h-6 shrink-0 border flex items-center justify-center transition-colors ${
            c.erledigt ? "bg-[#5E6B5A] border-[#5E6B5A] text-[#FAF8F5]" : "border-[#C8C0B0] hover:border-[#2B2825]"
        }`}
    >
        {c.erledigt && <Check size={14} strokeWidth={2.5} />}
    </button>
);

const ContactMeta = ({ c }) => (
    <div className="mt-5 grid sm:grid-cols-2 gap-x-8 gap-y-2 font-sans text-sm text-[#59534C]">
        <a href={`mailto:${c.email}`} className="inline-flex items-center gap-2 hover:text-[#2B2825]"><Mail size={14} /> {c.email}</a>
        {c.telefon && <a href={`tel:${c.telefon}`} className="inline-flex items-center gap-2 hover:text-[#2B2825]"><Phone size={14} /> {c.telefon}</a>}
        {c.anliegen && <p><span className="text-[#8C8275]">Anliegen:</span> {c.anliegen}</p>}
        <p><span className="text-[#8C8275]">Kontakt per:</span> {c.kontaktaufnahme}</p>
        {c.erreichbarkeit?.length > 0 && (
            <p className="sm:col-span-2"><span className="text-[#8C8275]">Erreichbar:</span> {c.erreichbarkeit.join(", ")}</p>
        )}
    </div>
);

export const ContactCard = ({ c, onDelete, onToggle }) => (
    <article
        data-testid={`admin-contact-${c.id}`}
        data-erledigt={c.erledigt ? "true" : "false"}
        className={`bg-[#FAF8F5] border p-6 sm:p-8 transition-opacity duration-300 ${c.erledigt ? "border-[#E6E1D5] opacity-60" : "border-[#DDD6C8]"}`}
    >
        <div className="flex flex-wrap items-start justify-between gap-4">
            <div className="flex items-start gap-4">
                <DoneToggle c={c} onToggle={onToggle} />
                <div>
                    <p className="font-sans text-[11px] tracking-[0.2em] uppercase text-[#8C8275]">
                        {formatDate(c.timestamp)}
                        {c.erledigt && <span className="ml-3 text-[#5E6B5A]">· Beantwortet</span>}
                    </p>
                    <h2 className={`font-serif text-2xl mt-1 ${c.erledigt ? "text-[#59534C] line-through decoration-[#C8C0B0]" : "text-[#2B2825]"}`}>
                        {c.vorname} {c.name}
                    </h2>
                </div>
            </div>
            <button
                data-testid={`admin-delete-${c.id}`}
                onClick={() => onDelete(c)}
                className="inline-flex items-center gap-1.5 font-sans text-xs text-[#8C8275] hover:text-[#A0522D] transition-colors"
            >
                <Trash2 size={14} /> Löschen
            </button>
        </div>
        <ContactMeta c={c} />
        {c.nachricht && (
            <p className="mt-5 font-sans text-sm leading-relaxed text-[#2B2825] bg-[#F4F1EA] border-l-2 border-[#5E6B5A] pl-4 py-3 whitespace-pre-wrap">
                {c.nachricht}
            </p>
        )}
    </article>
);
